import { useRecoilState } from 'recoil';
import dayjs from '_helpers/datetime';
import { computeGPA } from '_helpers/gpa';

import {useFetchWrapper} from '_helpers';
import {scoreAtom, pscoreAtom, alertBachAtom} from '_state';

export{ useStudentScoreAction };

function useStudentScoreAction (param) {
    const fetchWrapper = useFetchWrapper();
    const [score, setScore] = useRecoilState(scoreAtom);
    const [pscore, setpScore] = useRecoilState(pscoreAtom);
    const [alert, setAlert] = useRecoilState(alertBachAtom);

    async function getScoreList(Class, term_id){
        console.log("get student list called from studentInfo-action");
        const query = term_id ? `?term_id=${encodeURIComponent(term_id)}` : '';
        const response = await fetchWrapper.get(`/api/classes/${Class.class_id}/members/scores${query}`, null, null);
        if (response == null) {
            console.log("No response.");
            return null;
        }
        response.json().then(rawjson => { 
            console.log(rawjson);
            setScoreData (rawjson);
            return rawjson;
          }); 
    }

    async function getScoreByID(student_id, term_id, class_id){
        const params = new URLSearchParams();
        if (term_id)  params.set('term_id',  term_id);
        if (class_id) params.set('class_id', class_id);
        const query = params.toString() ? '?' + params.toString() : '';
        const response = await fetchWrapper.get(`/api/scores/${student_id}${query}`, null, null);
        if (response == null) {
            console.log("No response.");
            return null;
        }
        let rawjson = await response.json();
        return rawjson.message;
    }

    async function getMyScore(class_id){
        const query = class_id ? `?class_id=${encodeURIComponent(class_id)}` : '';
        const response = await fetchWrapper.get(`/api/scores/me${query}`, null, null);
        if (response == null) {
            console.log("No response.");
            return null;
        }
        let rawjson = await response.json();
        return rawjson.message;
    }

    function setScoreData (rawjson) {
        let data = rawjson.message
        setScore(data);
    }


    function handleData(data) {
        var refinedData = [];
        if (data != null) {
            data.forEach(object => {
                var student_id = object.user_ref.student_id;
                var name = object.user_ref.name;
                var scoreObj = object.scores;
                var date_of_birth = object.user_ref.date_of_birth = dayjs(object.user_ref.date_of_birth).format("DD/MM/YYYY");

                const gpa = computeGPA(scoreObj);
                const GPA = gpa.toFixed(3);
                const hasScores = scoreObj && scoreObj.length > 0;
                var state = !hasScores ? ['Chưa có điểm']
                    : (gpa >= 5.0) ? ['Bình thường']
                    : (gpa >= 2.5) ? ['Cảnh cáo']
                    : ['Đuổi học'];
                state = Array.from(state);
                const status = object.status.map(element => element.trim());
                state.push(...status);
                state = state.map(element => element.toLocaleLowerCase());
                refinedData.push({
                    student_id,
                    name,
                    date_of_birth,
                    cpa: GPA,
                    tags: state,
                });
            });
        }
        return refinedData;
    }

    async function updateScore(scoreId, newScore) {
        var urlencoded = new URLSearchParams();
        urlencoded.append("score", newScore);
        const response = await fetchWrapper.put(`/api/scores/update/${scoreId}`, "application/x-www-form-urlencoded", urlencoded);
        let rawjson = await response.json();
        return rawjson;
    }

    // Manually add a single score (manager/teacher). Mirrors the CSV import path
    // but for one (student, skill, score_type) cell at a time.
    async function addScore({ student_id, subject_code, score, score_type, class_id, term_id }) {
        var urlencoded = new URLSearchParams();
        urlencoded.append("student_id", student_id);
        urlencoded.append("subject_code", subject_code);
        urlencoded.append("score", score);
        urlencoded.append("score_type", score_type);
        if (class_id) urlencoded.append("class_id", class_id);
        if (term_id)  urlencoded.append("term_id", term_id);
        const response = await fetchWrapper.post(`/api/scores/add`, "application/x-www-form-urlencoded", urlencoded);
        let rawjson = await response.json();
        return rawjson;
    }

    return {
        getScoreList : getScoreList,
        getScoreByID : getScoreByID,
        getMyScore : getMyScore,
        handleData : handleData,
        updateScore : updateScore,
        addScore : addScore,
    }
}
